import React from 'react';
import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const MealIcon: React.FC<IIconProps> = React.memo(
    ({ className = '', icon = 'brown-100' }) => (

        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path 
            d="M10.125 2.75266V2.125H10.6875C10.9983 2.125 11.25 1.8826 11.25 1.58333V1.04167C11.25 0.742396 10.9983 0.5 10.6875 0.5H7.3125C7.00172 0.5 6.75 0.742396 6.75 1.04167V1.58333C6.75 1.8826 7.00172 2.125 7.3125 2.125H7.875V2.75266C4.0602 3.27977 1.125 6.43057 1.125 10.25H16.875C16.875 6.43057 13.9398 3.27977 10.125 2.75266ZM17.4375 11.3333H0.5625C0.251719 11.3333 0 11.5757 0 11.875V12.9583C0 13.2576 0.251719 13.5 0.5625 13.5H17.4375C17.7483 13.5 18 13.2576 18 12.9583V11.875C18 11.5757 17.7483 11.3333 17.4375 11.3333Z" 
            fill={theme.colors[icon]} />
        </svg>
    )
);

export default MealIcon;
